import { Row, Col } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { Button } from 'App/components'
import { createProcessingSelector, removeLicenseRequest, REMOVE_LICENSE } from 'store'

export type TLicensesRemoveDialogProps = {
  id: string
}

const processingRequest = createProcessingSelector([REMOVE_LICENSE])

export const LicensesRemoveDialog = ({ id }: TLicensesRemoveDialogProps) => {
  const dispatch = useDispatch()

  const processing = useSelector(processingRequest)

  const { t } = useTranslation()

  const handleClick = () => {
    dispatch(removeLicenseRequest({ id }))
  }

  return (
    <Row gutter={[0, 28]}>
      <Col xs={24}>
        <Row justify="center">
          <span>{t('modal.removeLicenseConfirm.content')}</span>
        </Row>
      </Col>
      <Col xs={24}>
        <Row justify="center">
          <Button loading={processing} onClick={handleClick}>
            {t('modal.removeLicenseConfirm.submitButton')}
          </Button>
        </Row>
      </Col>
    </Row>
  )
}
